import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SegmentoService } from 'src/app/service/segmento.service';
import { Segmento } from './segmento';

@Component({
  selector: 'app-segmento-form',
  templateUrl: './segmento-form.component.html',
  styleUrls: ['./segmento-shared.scss'],
})
export class SegmentoFormComponent implements OnInit {

  formulario: FormGroup;
  carregando = false;
  readonly tamanhoMaximoLogo = 1024 * 1024;

  constructor(
    private fb: FormBuilder,
    private service: SegmentoService,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.montarForm();
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.carregar(+id);
    }
  }

  montarForm(segmento?: Segmento) {
    this.formulario = this.fb.group({
      id: [segmento?.id ?? null],
      codigo: [segmento?.codigo ?? '', Validators.required],
      nome: [segmento?.nome ?? '', Validators.required],
      descricao: [segmento?.descricao ?? ''],
      ordem: [segmento?.ordem ?? null],
      ativo: [segmento?.ativo ?? true],
      logoBase64: [segmento?.logoBase64 ?? null],
      logoMimeType: [segmento?.logoMimeType ?? null],
      logoNomeArquivo: [segmento?.logoNomeArquivo ?? null],
      urlSistema: [segmento?.urlSistema ?? ''],
      fornecedorServidor: [segmento?.fornecedorServidor ?? ''],
      ipServidor: [segmento?.ipServidor ?? ''],
      usuarioRootServidor: [segmento?.usuarioRootServidor ?? ''],
      senhaServidor: [segmento?.senhaServidor ?? ''],
    });
  }

  ocultarSenhaServidor = true;

  get logoPreview(): string | null {
    const base64 = this.formulario?.get('logoBase64')?.value;
    if (!base64) {
      return null;
    }
    if (base64.startsWith('data:')) {
      return base64;
    }
    const mime = this.formulario?.get('logoMimeType')?.value || 'image/png';
    return `data:${mime};base64,${base64}`;
  }

  onLogoSelecionada(event: Event) {
    const input = event.target as HTMLInputElement;
    const arquivo = input.files?.[0];
    input.value = '';
    if (!arquivo) {
      return;
    }
    if (!arquivo.type.startsWith('image/')) {
      this.snackBar.open('Selecione um arquivo de imagem.', 'ERRO', { duration: 2500 });
      return;
    }
    if (arquivo.size > this.tamanhoMaximoLogo) {
      this.snackBar.open('A logo deve ter no máximo 1 MB.', 'ERRO', { duration: 2500 });
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      this.formulario.patchValue({
        logoBase64: reader.result as string,
        logoMimeType: arquivo.type,
        logoNomeArquivo: arquivo.name,
      });
      this.formulario.markAsDirty();
    };
    reader.readAsDataURL(arquivo);
  }

  removerLogo() {
    this.formulario.patchValue({
      logoBase64: null,
      logoMimeType: null,
      logoNomeArquivo: null,
    });
    this.formulario.markAsDirty();
  }

  carregar(id: number) {
    this.carregando = true;
    this.service.buscarPorId(id).subscribe(seg => {
      this.montarForm(seg);
      this.carregando = false;
    }, () => {
      this.carregando = false;
      this.snackBar.open('Segmento não encontrado.', 'ERRO', { duration: 2500 });
      this.voltarConsulta();
    });
  }

  submit() {
    if (this.formulario.invalid) {
      return;
    }
    const payload: Segmento = this.formulario.value;
    this.service.salvar(payload).subscribe(() => {
      this.snackBar.open('Segmento salvo com sucesso.', 'OK', { duration: 2500 });
      this.voltarConsulta();
    }, err => this.snackBar.open(err.error?.message ?? 'Erro ao salvar segmento.', 'ERRO', { duration: 3000 }));
  }

  limpar() {
    this.router.navigate(['/segmento/form']);
    this.montarForm();
  }

  voltarConsulta() {
    this.router.navigate(['/segmento/consulta']);
  }
}
